module.exports = __webpack_public_path__ + "img/aleks-kola.813b0218.jpg";